'use client';

import { SignUpForm } from "@/components/auth-related/sign-up-form";
import { isSignupsEnabled } from "@/lib/auth/mode";
import Image from 'next/image';
import Link from 'next/link';
import { redirect } from 'next/navigation';
import { useTheme } from 'next-themes';
import { Suspense, useSyncExternalStore } from 'react';

function SignUpContent() {
  const { resolvedTheme } = useTheme();
  const mounted = useSyncExternalStore(() => () => { }, () => true, () => false);

  if (!isSignupsEnabled()) {
    redirect("/auth/waitlist");
  }

  return (
    <div className="bg-muted p-4 min-h-svh">
      <div className="flex items-center gap-2 self-center font-medium">
        {mounted && (
          <Image
            src={resolvedTheme === 'dark' ? '/images/logo-dark.webp' : '/images/logo.webp'}
            alt="Logo"
            width={96}
            height={38}
            style={{ height: 'auto' }}
          />
        )}
      </div>
      <div className="flex  flex-col items-center justify-center gap-6">

        <div className="flex w-full max-w-sm flex-col gap-6">

          <SignUpForm />
        </div>

        <div
          aria-hidden="true"
          className="-z-10 pointer-events-none absolute left-0 top-0 w-full bg-gradient-overlay"
          style={{
            height: "100vh",
            transform: "rotate(180deg)"
          }}
        ></div>
      </div>
    </div>
  );
}

export default function Page() {
  return (
    <Suspense fallback={<div className="flex min-h-svh w-full items-center justify-center">Loading…</div>}>
      <SignUpContent />
    </Suspense>
  );
}
